import React from 'react';
import {Tooltip} from "@material-ui/core";
import {HashLink as Link} from "react-router-hash-link";
import {Button} from "@material-ui/core";

const ChangePasswordTextInput = ({customer = null,})=> {
    return(
        <Tooltip title={"Update your password."}>
            <div className={"row"} style={{color: "black"}}>
                <p className={"col-5 text-right align-self-center"}>Current Password:</p>
                <p className={"col-1"}> </p>
                <div className={"col-6 text-left"}>
                    <input type="text"
                           id="password"
                           name="password"
                           placeholder={"************"}
                           readOnly
                           />
                    &nbsp;
                    <Button
                        component={Link}
                        // smooth
                        to={'/password'}
                        variant={"outlined"}
                        color={"primary"}
                    >
                        Change Password
                    </Button>
                </div>
            </div>
        </Tooltip>
    )
}

export default ChangePasswordTextInput;